import React, { useEffect, useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import components from '../../components';
import { Link,Outlet,useNavigate, useLocation, useParams } from 'react-router-dom';
import ApiCall from '../../utils/Api';

const CheckProviderDetail = () => {
  const[data,setdata]=useState([])
  const[searchData,setsearchData]=useState("")
   const {id}=useParams()
    const navigate = useNavigate();
    const location = useLocation();
    const [key, setKey] = useState(location.key); // Add a key state to force re-render
  

  
    useEffect(() => {
      setKey(location.key); // Update the key state when the location changes
    }, [location]);
    const getAllProviderDataByAdmin=async()=>{
      try {
        console.log("🚀 ~ getAllProviderDataByAdmin ~ searchData:", searchData)

        const data=await ApiCall.SECURE_API.post(`/admin/searchProviderByWalletAddress?walletAddress=${searchData}`)
        console.log("🚀 ~ getAllProviderDataByAdmin ~ data:", data)
        

        if(Array.isArray(data.data.data)){
          console.log("🚀 ~ getAllProviderDataByAdmin ~ Array.isArray(data.data.dat:", Array.isArray(data.data.data))
          setdata(data.data.data)

        }else{
         let list=[data.data.data]
         setdata(list)

        }
      } catch (error) {
        console.log("🚀 ~ getAllProviderDataByAdmin ~ error:", error)
        setdata([])
      }
    }
    console.log('location', location)
    useEffect(()=>{
  
      getAllProviderDataByAdmin()
    },[searchData,location])
  return (
    <>
     {location.pathname=="/admin-panel/CheckProviderDetail/RegisterNewDataProvider"||location.pathname==`/admin-panel/CheckProviderDetail/PermissionsDetail/${id}`? <Outlet />:<div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='Loginheading'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>Provider Details</span> 
   {/* <Button onClick={()=>{
    navigate('/admin-panel/CheckProviderDetail/RegisterNewDataProvider');
   }}  variant="contained">Register New Data Provider</Button>  */}
    </div>  
 

     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                            <div style={{width:"95%",padding:27}} className='LoginScreen'>
                                <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
                                    <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                                        <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Provider Address</span>
                                    </div>
                                        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:10}}>
                                        <TextField style={{width:"100%"}} onChange={(e)=>{
                                          setsearchData(e.target.value)
                                          
                                        }} id="outlined-basic" label="Search Provider" variant="outlined" />
                                        <div >
                    
                                        </div>
                                        </div>
                                </div>
                            
                            
                              

                            </div>
                            <div style={{width:"98%",marginTop:40}}>
                                <components.Table.DataTable data={data} />    
                            </div>  
                            
            </div>
         
</div>}
</>
  )
}

export default CheckProviderDetail